import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DebugMessageWidget } from '../../widgets';
import { CenteringDiv } from '../../base/styled';

class Debug extends Component {
  render() {
    const { simpleCounter1, simpleCounter2 } = this.props;
    return (
      <div style={{ width: '100%', height: '100%' }}>
        <CenteringDiv>
          <DebugMessageWidget input={simpleCounter1} style={{ color: 'white' }} />
          <DebugMessageWidget input={simpleCounter2} style={{ color: 'white' }} />
        </CenteringDiv>
      </div>
    );
  }
}

Debug.propTypes = {
  simpleCounter1: PropTypes.shape({
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    data: PropTypes.shape({ message: PropTypes.string.isRequired }),
  }),
  simpleCounter2: PropTypes.shape({
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    data: PropTypes.shape({ message: PropTypes.string.isRequired }),
  }),
};

Debug.defaultProps = {
  simpleCounter1: {
    error: null,
    data: null,
  },
  simpleCounter2: {
    error: null,
    data: null,
  }
};

export default Debug;
